import React from 'react'

import AboutImage from '../images/about-riverton.jpg'

import Layout from '../components/layout'

const RivertonPage = () => (
  <Layout>
    <article className="cf ph3 ph5-ns pt5">
      <div className="fn fl-ns w-40-ns pr4-ns">
        <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
          Get to Know Riverton
        </h1>
        <h2 className="f4 mid-gray lh-title">
          A coastal Southland town that is well known for its <span className="turquoise">artistic</span> and <span className="turquoise">environmentally concerned</span> community
        </h2>
        <img className="" src={AboutImage} alt="Riverton by Adrian Blondell"/><small>Photo by Adrian Blondell</small>
      </div>
      <div className="fn fl-ns w-60-ns">
        <p className="measure mt0-ns">
          Riverton, also known as the Riviera of the South, is a coastal Southland town that is well known for its artistic and environmentally concerned community.
        </p>
        <p className="measure">
          The beach is never far away, and in summer dolphins can often been seen swimming in the river.  It’s a pleasantly slow pace of life where you will find four art galleries in the main street.  (Riverton Community Arts Centre, The Vault, The Good Studio and Studio 120) We’re an historical town, having been settled very early and we boast a beautiful little museum (Te Hikoi).
        </p>
        <p className="measure">
          While we only have one main street, there are many activities to do during your visit to Riverton.
        </p>
        <p className="measure">
          <ul>
            <li>Surf School</li>
            <li>Beaches (Don’t forget about Back Beach)</li>
            <li>Riverton Rocks</li>
            <li>Moores Reserve</li>
            <li>Te Hikoi</li>
            <li>Library</li>
            <li>Colac Bay</li>
            <li>Gemstone Beach (a bit of a drive, but well worth it)</li>
            <li>Monkey Island</li>
            <li>Cosy Nook </li>
            <li>Howells Point Reserve</li>
            <li>Art Classes</li>
            <li>Yoga</li>
            <li>Entertainment and Karaoke at the local pubs – The Aparima and Lodge</li>
            <li>Cafes Galore – Postmasters, The Beach House, The Crib, First In Cafe</li>
            <li>Riverton Environment Centre</li>
            <li>Drive the Southern Scenic Route</li>
            <li>Southland Arts Trail, Western Southland Arts Trail</li>
            <li>Visit local shops that mostly focus on arts and crafts</li>
          </ul>
        </p>
        <p className="measure">
          To be in the know about what’s happening in Riverton; join the Riverton Haven by the Sea Facebook Page and check out the What’s on In Riverton Facebook page for events.
        </p>
        <p className="measure">
          Riverton Annual Events:
        </p>
        <p className="measure">
          <ul>
            <li>Midwinter Market (End of July)</li>
            <li>Preston Russell Law Art Awards (April – May) at the Riverton Community Arts Centre</li>
            <li>Riverton Car Show</li>
            <li>Heritage Festival (Environment Centre)</li>
            <li>Christmas Markets</li>
            <li>Saturday Markets (During summer)</li>
          </ul>
        </p>
      </div>
    </article>
  </Layout>
)

export default RivertonPage
